/** Read a ZIP archive (stored or deflate) into a map of path → Uint8Array. */

function readName(bytes, start, length) {
  return new TextDecoder('utf-8').decode(bytes.subarray(start, start + length));
}

async function inflateRaw(comp) {
  if (typeof DecompressionStream === 'function') {
    const stream = new Blob([comp]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
    const buf = await new Response(stream).arrayBuffer();
    return new Uint8Array(buf);
  }
  throw new Error('This browser cannot read DOCX files.');
}

export async function unzipStore(buffer) {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const files = {};
  let offset = 0;

  while (offset + 30 <= bytes.length) {
    const sig = view.getUint32(offset, true);
    if (sig !== 0x04034b50) break;

    const flags = view.getUint16(offset + 6, true);
    const method = view.getUint16(offset + 8, true);
    const compSize = view.getUint32(offset + 18, true);
    const nameLen = view.getUint16(offset + 26, true);
    const extraLen = view.getUint16(offset + 28, true);
    const nameStart = offset + 30;
    const name = readName(bytes, nameStart, nameLen);
    const dataStart = nameStart + nameLen + extraLen;

    if (flags & 0x8) {
      throw new Error('This DOCX uses a ZIP format the importer cannot read. Save it again from Word and retry.');
    }
    if (dataStart + compSize > bytes.length) break;

    const comp = bytes.subarray(dataStart, dataStart + compSize);
    let data;
    if (method === 0) data = comp;
    else if (method === 8) data = await inflateRaw(comp);
    else throw new Error(`Unsupported ZIP compression method ${method}.`);

    files[name] = data;
    offset = dataStart + compSize;
  }

  return files;
}
